import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class AccessHours extends Component {
    static propTypes = {
        className: PropTypes.string,
        facility: PropTypes.object.isRequired,
        rate: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
        /** An optional title to set the section to. If none is set, the facility title is used. */
        sectionTitle: PropTypes.string,
    };

    _renderDisplayHoursComment() {
        const {rate} = this.props;

        if (!rate || !rate.display_hours_comment) {
            return null;
        }

        return (
            <p className="AccessHoursDetailsCentered">
                {rate.display_hours_comment}
            </p>
        );
    }

    _renderPeriods(hours) {
        return hours.map((period, i) => {
            return (
                <p className="hours-of-operation-period" key={i}>
                    <span className="day">{period.days}</span>
                    <span>{period.value}</span>
                    <br />
                </p>
            );
        });
    }

    _renderOffRate() {
        const {facility, rate} = this.props;
        const {access_hours_formatted: accessHoursFormatted} = rate;
        const {hours_of_operation: hoursOfOperation} = facility;

        if (accessHoursFormatted) {
            return (
                <div className="AccessHoursDetails">
                    {accessHoursFormatted.length === 1 &&
                    accessHoursFormatted[0].type === '247'
                        ? 'This facility is open 24/7.'
                        : this._renderPeriods(accessHoursFormatted)}
                </div>
            );
        } else {
            if (hoursOfOperation.text.length > 0) {
                return (
                    <p className="AccessHoursDetailsCentered">
                        {hoursOfOperation.text[0]}
                    </p>
                );
            } else {
                return null;
            }
        }
    }

    _renderOffFacility() {
        const {
            facility: {access_hours_formatted: accessHoursFormatted},
        } = this.props;

        return (
            <div className="AccessHoursDetails">
                {accessHoursFormatted.length === 1 &&
                accessHoursFormatted[0].type === '247'
                    ? 'This facility is open 24/7.'
                    : this._renderPeriods(accessHoursFormatted)}
            </div>
        );
    }

    render() {
        const {className, facility, rate, sectionTitle} = this.props;
        const classes = classNames(
            'SpotDetails-section',
            'AccessHours',
            className
        );
        const title = sectionTitle ? sectionTitle : facility.title;

        return (
            <div className={classes}>
                <h3 className="title">{title}</h3>
                {rate &&
                (rate.access_hours_formatted ||
                    rate.display_hours_comment ||
                    facility.hours_of_operation.text.length) ? (
                    <span>
                        {this._renderOffRate()}
                        {this._renderDisplayHoursComment()}
                    </span>
                ) : (
                    this._renderOffFacility()
                )}
            </div>
        );
    }
}
